<template>
  <BaseModal
    :is-editable="false"
    :is-archivable="false"
    :is-visible="isVisible"
    @hideModal="hideModal()"
  >
    <template #header>
      {{ $t('views.agreements.list.options.sendEmailProposition') }}
    </template>
    <template #body>
      <b-row align-h="around">
        <b-col cols="12" v-if="isCollectionMode">
          <p>{{ $t('views.agreements.list.sendEmailPropositionCollection') }}:</p>
          <ul>
            <li v-for="(agreement, index) in getAgreements" :key="'idClient_'+index">
              {{ agreement.idClientName }}
            </li>
          </ul>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <label>{{$t('views.agreements.form.offerExternalForm')}}:</label>
            <model-select :placeholder="$t('views.agreements.form.offerExternalForm')" :options="externalForms" v-model="externalFormId"></model-select>
          </b-form-group>
        </b-col>
        <b-col>
          <button type="button" class="btn btn-danger" @click="hideModal()">{{$t('buttons.cancel')}}</button>
        </b-col>
        <b-col>
          <button
            type="button"
            class="btn btn-success float-right"
            @click="sendProposition()"
          >
            {{$t('buttons.accept')}}
          </button>
        </b-col>
      </b-row>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import { ModelSelect } from 'vue-search-select'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'SendEmailPropositionModal',
  components: {
    BaseModal,
    ModelSelect
  },

  props: ['id', 'idCollection'],

  data () {
    return {
      externalForms: [],
      externalFormId: ''
    }
  },
  created () {
    this.fetchExternalForms()
  },
  computed: {
    isCollectionMode () {
      return !this.id
    },
    ...mapGetters({
      isVisible: 'agreements/emailPropositionModal/isVisible',
      response: 'agreements/emailPropositionModal/response',
      getAgreements: 'agreements/list/getAgreementsForMassEdit'
    })
  },
  watch: {
    isVisible (val) {
      if (val) {
        this.fetchAgreements({ idAgreements: this.idCollection })
      }
    },
    response () {
      this.hideModal()
    }
  },
  methods: {
    sendProposition () {
      if (this.isCollectionMode) {
        this.sendEmailPropositionForCollection({
          body: {
            'externalFormId': this.externalFormId,
            'agreements': this.idCollection
          }
        })
      } else {
        this.sendEmailProposition({
          id: this.id,
          body: {
            'externalFormId': this.externalFormId
          }
        })
      }
    },
    hideModal () {
      this.$emit('reset')
      this.toggleSendEmailPropositionModal()
    },
    async fetchExternalForms () {
      const response = await new ApiService('e_x_a_b_external_forms', { pagination: false, state: 1 }).getResults()
      this.externalForms = response.items.map(externalForm => {
        return {
          value: getId(externalForm['@id']),
          text: externalForm.title
        }
      })
    },
    ...mapMutations({
      toggleSendEmailPropositionModal: 'agreements/emailPropositionModal/toggleModal'
    }),
    ...mapActions({
      sendEmailProposition: 'agreements/emailPropositionModal/sendEmailProposition',
      sendEmailPropositionForCollection: 'agreements/emailPropositionModal/sendEmailPropositionForCollection',
      fetchAgreements: 'agreements/list/fetchAgreementsForMassEdit'
    })
  }
}
</script>
